<template>
  <div class="notices" @click="goToDetail" v-if="show">
    {{title}}
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Notices',
  data() {
    return {
      guardedRoute: [
        'home',
      ],
      visible: true,
      //notices: {}
    }
  },
  props: {
       
  },
  computed: {
    ...mapGetters({
      notices: 'notices/current',
    }),
    title() {
      return this.notices && this.notices.title && this.notices.title ? this.notices.title : '' 
    },
    show() {
      return this.notices && this.notices.body && this.guardedRoute.indexOf(this.$route.name) !== -1
    }
  },  
  methods: {
    ...mapActions({
      getNotices: 'notices/getNotices'
    }),
    goToDetail() {
      this.$router.push({ name: 'notices', params: { body: this.notices.body } })
    }
  },
  async mounted() {
    const { data } = await this.getNotices()
  },
}
</script>

<style scoped>
  .notices {
    top: 0px;
    width: 100%;
    height: 20px;
    background: #ff1744;
    z-index: 2;
    color: #fff;
  }
</style>


// WEBPACK FOOTER //
// src/modules/common/components/notices/notices.vue